import { defineMessages } from 'react-intl';

const messages = defineMessages({
  currentCostOnPremisesLabel: {
    id: 'L0a3ir',
    defaultMessage: 'Current cost per on-premises host (USD):',
  },
  localCurrencie: {
    id: '35V5JI',
    defaultMessage: 'with local currency',
  },
  contactInfo: {
    id: '5axkLt',
    defaultMessage: 'For a solution this size please get in touch with us.',
  },
  estimatedRoi: {
    id: 'hxKOo2',
    defaultMessage: 'Estimated ROI',
  },
  annualGrowthRateLabel: {
    id: 'YIZSyD',
    defaultMessage: 'Annual growth rate %',
  },
  annualGrowthRateDescTooltip: {
    id: '5elpIl',
    defaultMessage:
      'Enter the approximate annual growth rate for the number of on-prem VMs, or cloud instances.',
  },
  footnoteOne3: {
    id: '0BLM5T',
    defaultMessage:
      'with factors comparable to your inputs based on customers’ reported data, consistent linear spend, and other technical and financial assumptions. There may be additional unaccounted for costs related to the use and deployment of Turbonomic that are not accounted for with this calculator. For a more precise estimate, submit a request for more information to obtain a savings estimate unique to your environment. The results shown by the tool are provided for illustrative purposes only, may not be accurate or applicable to you, and will vary based on your particular business conditions, usage, and configurations and environment, among other factors. Results from the calculator should not be relied upon, are not a guarantee or commitment to you regarding any potential or actual financial results you may achieve, may not be incorporated into any contract, and will not create any liability or obligation for IBM. The calculator is provided on an “AS IS” basis, without warranty of any kind.',
  },
  footnoteOne2: {
    id: '6UDbdZ',
    defaultMessage: 'results reported by a sample of IBM customers',
  },
  footnoteOne1: {
    id: 'xr+tA7',
    defaultMessage: 'The results shown are illustrative of',
  },
  calculationMessage: {
    id: 'E1Gwsp',
    defaultMessage: 'Estimated 3-year savings',
  },
  annualGrowthRateCloudInstanceescTooltip1: {
    id: 'SWlF5M',
    defaultMessage:
      'Enter the approximate annual growth rate of the number of cloud instances being added to your public cloud environment(s). A default of',
  },
  inlineTextTitleSaaS: {
    id: 'j3GVIG',
    defaultMessage: 'Software as a service information',
  },
  foundCountry: {
    id: 'q0Y/L/',
    defaultMessage: 'Found country',
  },
  widgetInfo1: {
    id: 'dMSBZc',
    defaultMessage: 'Voted Best ROI on G2',
  },
  TotalCurrentCostOnPremHostTilte: {
    id: 'cZHHW2',
    defaultMessage: 'Current cost per on-premises host (USD)',
  },
  inlineTextTitleLicense: {
    id: 'xT02Hd',
    defaultMessage: 'Software license subscription information',
  },
  contactUs: {
    id: 'WnQ/AZ',
    defaultMessage: 'Contact us',
  },
  totalOnPremVvmsTitle: {
    id: 'zU4Qnw',
    defaultMessage: 'Number of on-premises VMs',
  },
  widgetInfo2: {
    id: 'U1mTVM',
    defaultMessage: 'Forrester TEI study (915 KB)',
  },
  stayHere: {
    id: '4jk4C+',
    defaultMessage: 'No, thanks. Stay here',
  },
  returnToEstimator: {
    id: '1fHL/5',
    defaultMessage: 'Return to ROI estimator',
  },
  currentMonthlyCloudBillLabel: {
    id: 'B9hYn7',
    defaultMessage: 'Current monthly cloud bill (USD):',
  },
  totalCurrentNumberOnPremHostsTitle: {
    id: 'g+V56I',
    defaultMessage: 'Current number of on-premises hosts',
  },
  getQuoteButton: {
    id: 'zEVTyS',
    defaultMessage: 'Get more information',
  },
  annualGrowthRateOnPremVMTitle: {
    id: 'fOmivl',
    defaultMessage: 'Annual growth rate on-premises VMs:',
  },
  widgetInfo: {
    id: 'BbW0a8',
    defaultMessage:
      'IBM Turbonomic experts will work with you to reach your business goals—one of many reasons we are rated',
  },
  ContactBP: {
    id: 'MsiLjH',
    defaultMessage: 'Contact IBM Business Partner',
  },
  annualGrowthRateCloudInstanceTitle: {
    id: 'DHpDOj',
    defaultMessage: 'Annual growth rate cloud instances:',
  },
  annualGrowthRateOnPremVMLabel: {
    id: 'bETJPe',
    defaultMessage: 'On-premises VMs',
  },
  availableIn: {
    id: 'igQyQv',
    defaultMessage: 'The Turbonomic estimator is available in',
  },
  annualGrowthRateCloudInstanceLabel: {
    id: 'Utsf6P',
    defaultMessage: 'Cloud Instance',
  },
  totalCloudInstancesTitle: {
    id: 'ExXiFI',
    defaultMessage: 'Number of cloud instances',
  },
  thankYouSubTitle: {
    id: 'PwjLGb',
    defaultMessage: 'We have received your request',
  },
  accessPageCapitalized: {
    id: 'GjxKEi',
    defaultMessage: 'Access page in',
  },
  currentCostOnPremisesDescTooltip: {
    id: 'W0KEIO',
    defaultMessage:
      'Enter the average cost for one of your physical servers, including hardware, operating system, and management software licensing per server. A default of $25,000 per host has been selected based on experience with our clients.',
  },
  monthlyCloudBillHeadTooltip: {
    id: 'w1mgmk',
    defaultMessage: 'Current monthly cloud bill',
  },
  oneYearEstimatedCosts: {
    id: '7U4yNh',
    defaultMessage: '1 Year estimated price',
  },
  annualGrowthRateCloudInstanceHeadTooltip: {
    id: 'lw/NUO',
    defaultMessage: 'Cloud instance',
  },
  totalCurrentMonthtlyCloudBillTitle: {
    id: 'dvG40V',
    defaultMessage: 'Current monthly cloud Bill (USD)',
  },
  monthlyCloudBillDescTooltip: {
    id: '6GhL4j',
    defaultMessage:
      'Although Turbonomic is licensed per managed virtual server (MVS), it also optimizes cloud volumes and databases included as part of the price. Please enter your estimated monthly cloud bill for all servers, volumes and databases to generate an accurate estimate of Turbonomic generated savings. A default of $100 per cloud instance per month has been selected based on experience with our clients.',
  },
  currentCostOnPremisesHeadTooltip: {
    id: 'wsgHGO',
    defaultMessage: 'Current cost per host',
  },
  defineMessages: {
    id: 'rbrahO',
    defaultMessage: 'Close',
  },
  tableHeaderColumn2: {
    id: 'GufXy5',
    defaultMessage: 'Value',
  },
  widgetText_1: {
    id: 'cg4dwh',
    defaultMessage:
      'Estimate your IBM Turbonomic return on investment (ROI) today',
  },
  tableHeaderColumn1: {
    id: 'xLigG0',
    defaultMessage: 'Selection',
  },
  widgetText_4: {
    id: 'Up4i9p',
    defaultMessage: 'An ROI leader',
  },
  widgetText_2: {
    id: 'jdDlgB',
    defaultMessage: 'Also see the',
  },
  widgetText_3: {
    id: 'QsmE2j',
    defaultMessage: 'on how IBM Turbonomic delivers 471% ROI over three years.',
  },
  numberOnPremHostsDescTooltip: {
    id: 'OHzjZP',
    defaultMessage:
      'Please enter the total number of on-premises physical machine hosts on which the On-prem VMs reside.',
  },
  labelNumberOnPremHosts: {
    id: 'LHU1Dq',
    defaultMessage: 'Current number of on-premises hosts:',
  },
  takeMeThere: {
    id: 'GeEQEA',
    defaultMessage: 'Take me there',
  },
  thankYouTitle: {
    id: 'aYIUar',
    defaultMessage: 'Thank you!',
  },
  thankYouDetailsTitle: {
    id: '0L49M8',
    defaultMessage: 'Request details:',
  },
  invalidVmText_1: {
    id: 'xK7hCb',
    defaultMessage: 'Maximum to process is',
  },
  invalidVmText_2: {
    id: 'xIWCOZ',
    defaultMessage: '. Please contact us',
  },
  invalidVmText_3: {
    id: 'U/FjKc',
    defaultMessage: 'Minimum to process is',
  },
  annualGrowthRateHeadTooltip: {
    id: 'zW55FI',
    defaultMessage: 'Annual growth rate',
  },
  inlineTextLicense: {
    id: 'mQxRPU',
    defaultMessage: 'Pricing does not include the cost of infrastructure.',
  },
  contactInfo2: {
    id: 'fJD4UX',
    defaultMessage:
      'You may qualify for volume discounting! Request a quote for the best possible price.',
  },
  annualGrowthRateOnPremVMDescTooltip2: {
    id: 'B9QGYF',
    defaultMessage: '% has been selected based on experience with our clients.',
  },
  threeYearEstimatedCosts: {
    id: '2A0O3x',
    defaultMessage: '3 Year estimated price',
  },
  annualGrowthRateOnPremVMDescTooltip1: {
    id: 'HMQSGm',
    defaultMessage:
      'Enter the approximate annual growth rate of the number of On-prem VMs being added to your environment(s). A default of',
  },
  numberOnPremHostsHeadTooltip: {
    id: '3us2E+',
    defaultMessage: 'Number of on-premises hosts',
  },
  inlineTextSaaS: {
    id: 'zclhua',
    defaultMessage:
      'All the benefits of the IBM Turbonomic platform without the need to invest in hardware and software',
  },
  accessPage: {
    id: 'Z02o6s',
    defaultMessage: 'access page in',
  },
});

export default messages;
